import axios from 'axios';
// import { useHistory } from 'react-router-dom';
import { ProfileActions } from './profileAction';
import { getServerCore } from '../../../../utils/apiUtils';
import { showSuccessSnackbar } from '../../Snackbar/snackbar.action';

const { serverUrls } = getServerCore();
const authUrl = serverUrls.getAuthUrl();

export const resetPasswordAsync = (password) => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch(ProfileActions.resetPasswordStart());
            const { data } = await axios({
                method: "POST",
                url: `${authUrl}/resetPassword/${_id}`,
                data: password,
            });
            if (data.responseCode === 200) {
                dispatch(ProfileActions.resetPasswordSuccess(data.responseData));
                return dispatch(showSuccessSnackbar('success', data.responseMessage, 3000));
            }
            return dispatch(ProfileActions.resetPasswordError());
        } catch (error) {
            dispatch(ProfileActions.resetPasswordError());
            dispatch(showSuccessSnackbar('error', "Error while reseting password.Please try again after sometime.", 3000));
        }
    }
}

export const startProfileKyc = () => {
    // let history = useHistory();
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            const data = await axios({
                method: "GET",
                url: `${authUrl}/rfid/createNewSession/${_id}`
                
            });

            const kycStatus = await axios({
                method: 'GET',
                url: `${authUrl}/kycStatus/${_id}`
            })
            if(data.data.responseCode && data.data.responseCode != 200) {
                return dispatch(showSuccessSnackbar('error', data.data.responseMessage || 'Something went wrong', 3000));
            }
            
            let url = data.data.url
            window.open(url, '_blank');
            return dispatch(ProfileActions.kycUpdated({kycData: {...data.data, ...kycStatus.data } }))                
        }
        catch (error) {
            console.log('here')
            // dispatch(ProfileActions.resetPasswordError());
            return dispatch(showSuccessSnackbar('error', error.responseMessage || 'Something went wrong', 3000));
        
        }
    }
}

export const updateProfileKyc = () => {
    // let history = useHistory();
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
                const data = await axios({
                    method: "POST",
                    url: `${authUrl}/rfid/updateCustomer/${_id}`,
                    data: {
                        "reasonForRepeat": "test"
                    }
                    
                });

                console.log(data)
    
                const kycStatus = await axios({
                    method: 'GET',
                    url: `${authUrl}/kycStatus/${_id}`
                })

                if(data.data.responseCode && data.data.responseCode != 200) {
                    return dispatch(showSuccessSnackbar('error', data.data.responseMessage || 'Something went wrong', 5000));
                }
                
                //if(data.data.responseCode == 200) {
                    let url = data.data.url
                    window.open(url, '_blank');
                    dispatch(ProfileActions.kycUpdated({kycData: {...data.data, ...kycStatus.data } }))
                    return dispatch(showSuccessSnackbar('success', data.data.responseMessage || 'Your KYC updated', 5000));
                //}
                //return dispatch(showSuccessSnackbar('error', data.data.responseMessage || 'Something went wrong', 5000));
            
        }
        catch (error) {
            console.log('here')
            // dispatch(ProfileActions.resetPasswordError());
            return dispatch(showSuccessSnackbar('error', error.responseMessage || 'Something went wrong', 3000));
        
        }
    }
}

export const kycStatusCheck = () => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            const kycStatus = await axios({
                method: 'GET',
                url: `${authUrl}/kycStatus/${_id}`
            })
           
           
            return dispatch(ProfileActions.kycUpdated({kycData: {...kycStatus.data } }))
        }
        catch (error) {
            return dispatch(showSuccessSnackbar('error', error.responseMessage || 'Something went wrong', 3000));
        }
    }
}




